module.exports = __webpack_public_path__ + "img/MiOriental-G.77666182.png";